import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';

import { useLocalTranslation } from '../../../common/hooks/useLocalTranslation';

interface SurveyCompleteProps {
  clientName: string;
  currentLanguage: string;
  logo?: string;
  isPreview?: boolean;
}

export const PublicSurveyComplete: React.FC<SurveyCompleteProps> = ({
  clientName,
  logo,
  currentLanguage,
  isPreview = false,
}) => {
  const { t, tk } = useLocalTranslation('administrationLng', currentLanguage);
  return (
    <div
      className={`public-survey-hero-bg ${isPreview ? 'public-survey-hero-bg--preview' : ''} d-flex align-items-center justify-content-center p-4`}
    >
      <div className="public-survey-complete-wrapper">
        <div className="public-survey-complete-card">
          {logo && (
            <div className="public-survey-landing-logo-wrapper">
              <img src={logo} alt="" className="public-survey-landing-logo" />
            </div>
          )}
          <div className="public-survey-complete-icon">
            <FaCheckCircle size={40} />
          </div>

          <h1 className="public-survey-complete-title">
            {t(tk.publicSurvey.thankYou)}
          </h1>

          <p className="public-survey-complete-description">
            {t(tk.publicSurvey.answersSaved)}
          </p>

          <p className="public-survey-complete-brand">
            {t(tk.publicSurvey.surveyCompletedBy)} <strong>{clientName}</strong>
          </p>
        </div>
      </div>
    </div>
  );
};
